<template>
  <div class="container flex-row-space-evenly">
    <img src="../../img/qui_sommes_nous/petits_points_blanc.svg" alt="">

    <div class="content flex-column">
      <img src="../../img/qui_sommes_nous/antenne_parabole.svg" alt="">
      <p>Qui sommes <span>nous ?</span></p>
      <button @click="changeTo('societe')">En savoir plus</button>
      <div class="space"></div>
    </div>
  </div>
</template>

<script>
    import {menuBus} from "../../main";

    export default {
        methods: {
            changeTo(pageName, id) {
                menuBus.$emit('changePage', pageName, id);
            }
        },
        mounted() {
            menuBus.$on('changePage', (pageName, idName) => {
                this.menuShowed = false;
            });
        }
    }
</script>

<style scoped>
  .container {
    background: url("../../img/qui_sommes_nous/image.png") no-repeat center center fixed;
    height: 500px;
    width: 100%;
    background-size: cover;

    position: relative;
  }

  .container > img {
    position: absolute;
    top: -50px;
    left: -40px;
    height: 60%;
  }

  .content img {
    height: 100px;
  }
  .content p {
    color: white;
    font-size: 30px;
    text-transform: uppercase;
    font-weight: 100;
  }
  .content p span {
    font-weight: 700;
  }
  .content button {
    background: none;
    color: white;
    font-family: Arial;
    text-transform: uppercase;
    border: 1px solid rgba(255, 255, 255, 0.71);
    padding: 15px;
    cursor: pointer;
    transition: all 0.2s;
  }
  .content button:hover {
    background-color: white;
    border: 1px solid rgba(255, 255, 255, 0);
    color: #162139;
  }
  .content .space {
    height: 50px;
  }

  @media (max-width: 700px) {
    .container {
      height: 350px;
    }
    .container > img {
      display: none;
    }
    .content {
      margin: 0 20px;
    }
    p {
      font-size: 25px !important;
    }
    .content img {
      height: 80px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/accueil/QuiSommesNous.vue